import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import GpsFixedOutlinedIcon from '@material-ui/icons/GpsFixedOutlined';
import { connect } from 'react-redux';
import { numberFormat, getDateInStringDDMMMYYYY, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import ConfirmDialog from '../Dialog/ConfirmDialog';
import {
    getTripDetailsV3,
    deleteVendorExpense,
    deletePartyPayment,
    paymentCancel
} from "../../../store/actions/tripActionCreator";
import { sendError, sendSucces } from "../../../utils/utils";
import Slide from '@material-ui/core/Slide';
import {
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    Button
} from '@material-ui/core';
import * as logger from '../../../logger';

const useStyles = makeStyles((theme) => ({
    dialogV1: {
        borderRadius: 14
    },
    dialogTitleV1: {
        fontSize: 16
    },
    discardButton: {
        color: 'grey',
        fontWeight: 'bold',
        letterSpacing: 1
    },
    removeButton: {
        color: 'red',
        fontWeight: 'bold',
        letterSpacing: 1
    },
    dialogActionsV1: {
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 10,
        paddingBottom: 10
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DeletePartyPaymentInitiated = ({ open, onClose, paymentData, deleteId, onDeleteConfirm, dispatchCancelPayment }) => {

    const classes = useStyles();
    const [dialogOpen, setDialogOpen] = useState(open);

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const handleConfirm = () => {

        dispatchCancelPayment(deleteId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Delete Party Payment Initiated Dweb", "Cancel Party Payment Successfull");
                    setDialogOpen(false);
                    onDeleteConfirm();
                }
            },
            () => {
                logger.log("Delete Party Payment Initiated Dweb", "Cancel Party Payment Failed");
            }
        )

    }

    return (
        <>
            {dialogOpen &&
                <Dialog
                    open={dialogOpen}
                    TransitionComponent={Transition}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                    maxWidth="sm"
                    classes={{ paperScrollPaper: classes.dialogV1 }}
                >
                    <DialogTitle id="alert-dialog-slide-title" className={classes.dialogTitleV1}>Cancel Payment Request?</DialogTitle>
                    <DialogContent>
                        Proceed to cancel the payement request of {paymentData && <span style={{ fontWeight: 'bold', marginLeft: 2 }}>{paymentData}</span>}
                    </DialogContent>
                    <DialogActions className={classes.dialogActionsV1}>
                        <Button onClick={handleClose} className={classes.discardButton}>
                            DISCARD
                        </Button>
                        <Button onClick={handleConfirm} className={classes.removeButton}>
                            REMOVE
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </>
    )

}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
    dispatchCancelPayment: (paymentId, onSuccess, onFailure) => {
        dispatch(paymentCancel(paymentId, onSuccess, onFailure))
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(DeletePartyPaymentInitiated);